import { Button, useTheme, useMediaQuery, Theme, ButtonProps } from '@mui/material';

export const StyledButton = ({ ...props }: ButtonProps): JSX.Element => {
  const theme = useTheme();
  const size: 'large' | 'medium' = useMediaQuery((theme as Theme).breakpoints.up('lg')) ? 'large' : 'medium';
  return <Button {...{ ...props, size }}>{props.children}</Button>;
};
